import { observable, decorate } from "mobx";
import { persist } from "mobx-persist";

export class AuthStore {
  isLoggedIn = false;
  prefix = "disha";
  scope = [];
  name = null;
  email = null;
  id = null;
  hospitalName = "DISHA EYE HOSPITALS PRIVATE LIMITED";
  selectedBranchName = null;
  selectedBranchId = null;

  // Set dark mode on login
  setDarkModeOnLogin = () => {
    localStorage.setItem("theme", "dark");
    document.documentElement.setAttribute("data-theme", "dark");
    // Force dark mode CSS variables
    const root = document.documentElement;
    root.style.setProperty("--bg-primary", "#1a1a1a");
    root.style.setProperty("--bg-surface", "#2d2d2d");
    root.style.setProperty("--bg-surface-light", "#3a3a3a");
    root.style.setProperty("--text-primary", "#ffffff");
    root.style.setProperty("--text-secondary", "#b3b3b3");
    root.style.setProperty("--text-tertiary", "#808080");
    root.style.setProperty("--border-color", "#404040");
    root.style.setProperty("--border-light", "#555555");
    root.style.setProperty("--nav-text-color", "#ffffff");
  };

  // Branch selection setters/getters
  setSelectedBranchByName = (branchName) => {
    this.selectedBranchName = branchName || null;
  };

  setSelectedBranchById = (branchId) => {
    this.selectedBranchId = branchId || null;
  };

  clearSelectedBranch = () => {
    this.selectedBranchName = null;
    this.selectedBranchId = null;
  };
}

decorate(AuthStore, {
  name: [persist, observable],
  email: [persist, observable],
  id: [persist, observable],
  isLoggedIn: [persist, observable],
  prefix: [persist, observable],
  scope: [persist("list"), observable],
  hospitalName: [persist, observable],
  selectedBranchName: [persist, observable],
  selectedBranchId: [persist, observable],
});
export default new AuthStore();
